exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gw-portal-checkout-billing{display:block}gw-portal-checkout-billing .gw-button[type=submit]{margin:0 auto;width:12.5em}.gw-payment-icon{position:relative;display:block;width:32px;height:20px}.gw-billing-heading{margin-bottom:12px;padding-bottom:6px;font-size:18px;border-bottom:1px solid #d4d4d4;line-height:1}.gw-recent-order-warning{display:block;margin-bottom:24px;padding:24px;background-color:#fcf6ed;border:1px solid #ccc}.gw-billing-total{width:100%;background-color:#f2f8fa;font-weight:lighter;padding:10px;text-align:center}.gw-billing-total__amount{font-weight:700;color:#3c7ec8}.gw-submit__under-text{font-size:11px;color:gray;padding-top:15px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/components/checkout/submit/submit.scss
// module id = bLlV
// module chunks = 1